import { css } from "styled-components";
import { TOKENS } from "../consts";
import getTypeToken from "./getTypeToken";

var getFocus = function getFocus() {
  return css([":focus{background:", ";}:focus:not(:focus-visible){background:", ";}:-moz-focusring,:focus-visible{background:", ";}"], getTypeToken(TOKENS.backgroundButtonFocus), getTypeToken(TOKENS.backgroundButton), getTypeToken(TOKENS.backgroundButtonFocus));
};

export default getFocus;